export const SET_IS_COMPANY = 'SET_IS_COMPANY';
export const SET_FIRST_NAME = 'SET_FIRST_NAME';
export const SET_LAST_NAME = 'SET_LAST_NAME';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_PHONE = 'SET_PHONE';
export const SET_COUNTRY = 'SET_COUNTRY';
export const SET_COMPANY_NAME = 'SET_COMPANY_NAME';
export const SET_COMPANY_ADDRESS = 'SET_COMPANY_ADDRESS';
export const SET_REG_NUM = 'SET_REG_NUM';
export const SET_IBAN = 'SET_IBAN';
export const SET_BANK = 'SET_BANK';
export const SET_BIC = 'SET_BIC';
export const SET_VAT_NUMBER = 'SET_VAT_NUMBER';
export const SET_TERMS_AGREE = 'SET_TERMS_AGREE';
export const SET_MAILING_LIST_AGREE = 'SET_MAILING_LIST_AGREE';
export const SET_TERMS_CONDITIONS_AGREE = 'SET_TERMS_CONDITIONS_AGREE';

export const SET_TEMPLATES = 'SET_TEMPLATES';
export const SET_PROPERTIES = 'SET_PROPERTIES';
export const SET_TICKETS = 'SET_TICKETS';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_SINGLE_PRODUCTS = 'SET_SINGLE_PRODUCTS';
export const SET_GROUP_PRODUCTS = 'SET_GROUP_PRODUCTS';
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
export const SET_DISCOUNT_CODE = 'SET_DISCOUNT_CODE';
export const SET_SHOW_PAYMENTS = 'SET_SHOW_PAYMENTS';
export const SET_WIDGET_SHOW = 'SET_WIDGET_SHOW';
export const SET_IS_PLUGIN = 'SET_IS_PLUGIN';